import React, { Component } from 'react';
import { Link } from "react-router-dom";

class CCI2025 extends Component {
  componentDidMount() {
    window.startx();
  }
  render() {
    return (
      <div id="main" className="wrapper style1">
        <div className="container">
          <header className="major">
            <h2>25° Concurso de Creatividad e Ingenio</h2>
          </header>
          <div className="containerimagenblog">
          <img className="imagenBlog" src="images/Blog/portada5.jpg" alt="Simulacro 2023" />
          </div>
          <span className="containerblog">
              <div className="align justify">
                <p>
                  ¡Innova, experimenta y sé parte de esta historia! El Museo Interactivo El Rehilete te invita a participar 
                  en la 25ª edición del Concurso de Creatividad e Ingenio, un espacio donde las ideas cobran vida y 
                  la curiosidad se transforma en descubrimiento.
                </p>
                <p>
                  Durante más de dos décadas, este concurso ha impulsado a miles de estudiantes hidalguenses a imaginar, diseñar 
                  y construir prototipos y proyectos innovadores que buscan inspirar al mundo. A lo largo de su historia, ha sido 
                  semillero de talento, creatividad y pasión por la ciencia, la tecnología y la resolución de problemas reales.

                </p>
                <p>
                  En esta edición especial, celebramos 25 años de fomentar la innovación y el pensamiento científico, invitando a nuevas generaciones a dejar su huella con propuestas que reflejen ingenio, compromiso y visión hacia el futuro. 
                  ¡Es momento de convertir tus ideas en inspiración!
                </p>
                <h3>
                  Consulta las bases del concurso y elige tu nivel de participación:
                </h3>
                Bases completas del concurso:
                <ul>
                  <li>
                    <a href=' www.museoelrehilete.org.mx/PDF/cartel2025.pdf'>Convocatoria</a>
                  </li>
                  
                </ul>
                Inscripciones Nivel Medio Superior:
                <ul>
                  <li>
                    <a href='https://goo.su/YsUqpU'>Nivel Medio Superior</a>
                  </li>
                </ul>
                  Inscripciones Nivel Superior:
                <ul>
                  <li>
                 <a href='https://goo.su/s1CDRo'>Nivel Superior</a>
                  </li>
                </ul>
            </div>
            <div>
              <div className="containerjuego">
                 <Link className="button" to="/blog">
                Regresar
              </Link>
              </div>
            </div>
          </span>
        </div>
      </div>
    );
  }
}

export default CCI2025;